import { FunctionComponent, useEffect } from 'react';
import { Page, Loader } from '@gaiads/telia-react-component-library';
import { ForbiddenErrorErrorEnum } from '@cdaas/api-clients/dist/asset-user-openapi';
import { useLocation, useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import * as actions from '../../../store/actions';
import { RootState } from '../../../store/reducers';
import { getStorageItem } from '../../../utils';

const Authenticated: FunctionComponent = () => {
  const location = useLocation();
  const history = useHistory();
  const loading = useSelector((state: RootState) => state.authentication.loading);
  const error = useSelector((state: RootState) => state.authentication.error);
  const dispatch = useDispatch();
  const authenticate = (code: string, returnUrl: string, path: string) => dispatch(actions.authenticate(code, returnUrl, path));

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const authCode = query.get('code');
    const receivedState = query.get('state');
    const authInfo = getStorageItem<{ state: string; path: string }>('tState', 'local', true);

    if (!authInfo) {
      history.push('/authentication/login');
      return;
    }
    const sentState = authInfo.state;

    if (!authCode || receivedState !== sentState) {
      history.push('/authentication/login');
    } else {
      authenticate(authCode!, process.env.REACT_APP_AUTH_RETURN_LINK!, authInfo.path);
    }
    // location.search is not as dependency as we only want to run this when mounted
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (error.status) {
      if (error.message === ForbiddenErrorErrorEnum.Forbidden) {
        history.push('/authentication/access-failed');
      } else if (error.message === ForbiddenErrorErrorEnum.PrescheduledOnboardingInFuture) {
        history.push('/authentication/access-not-yet-available');
      } else {
        history.push('/authentication/login-failed');
      }
    }
    // history cannot be a dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error.status, error.message]);

  return (
    <Page>
      <Page.Ingress alignTextToCenter margin={{ top: 'xxlg', bottom: 'xxlg' }}></Page.Ingress>
      <Page.Row alignTextToCenter>{loading ? <Loader /> : null}</Page.Row>
    </Page>
  );
};

export default Authenticated;
